import { Container } from "../../../elements/Container";
import { styles } from "../TestimonialModule.style";

export interface TrustStat {
  value: string;
  label: string;
}

export interface TestimonialStatsProps {
  stats: TrustStat[];
}

export const TestimonialStats = ({ stats }: TestimonialStatsProps) => {
  if (!stats.length) return null;

  return (
    <div className={styles.statsRow}>
      <Container>
        <dl className={styles.statsList}>
          {stats.map((stat, i) => (
            <div key={i} className={styles.statItem}>
              <dt className={styles.statValue}>{stat.value}</dt>
              <dd className={styles.statLabel}>{stat.label}</dd>
            </div>
          ))}
        </dl>
      </Container>
    </div>
  );
};
